/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolChurchIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-church"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M1.68 19.68L1.68 15.53Q1.68 14.72 2.1 14.07Q2.52 13.43 3.25 13.1L5.67 12.03L5.67 10.45Q5.67 9.7 6.08 9.06Q6.47 8.43 7.15 8.07L10.68 6.3L10.68 5.33L10 5.33Q9.45 5.33 9.06 4.94Q8.68 4.55 8.68 4Q8.68 3.45 9.06 3.06Q9.45 2.67 10 2.67L10.68 2.67L10.68 2Q10.68 1.45 11.06 1.06Q11.45 0.68 12 0.68Q12.55 0.68 12.94 1.06Q13.32 1.45 13.32 2L13.32 2.67L14 2.67Q14.55 2.67 14.94 3.06Q15.32 3.45 15.32 4Q15.32 4.55 14.94 4.94Q14.55 5.33 14 5.33L13.32 5.33L13.32 6.3L16.85 8.07Q17.52 8.43 17.93 9.06Q18.32 9.7 18.32 10.45L18.32 12.03L20.75 13.1Q21.48 13.43 21.9 14.07Q22.32 14.72 22.32 15.53L22.32 19.68Q22.32 20.8 21.56 21.56Q20.8 22.32 19.68 22.32L15.57 22.32Q15.03 22.32 14.64 21.94Q14.25 21.55 14.25 21L14.25 19.07Q14.25 18.18 13.57 17.5Q12.9 16.82 12 16.82Q11.1 16.82 10.43 17.5Q9.75 18.18 9.75 19.07L9.75 21Q9.75 21.55 9.36 21.94Q8.97 22.32 8.43 22.32L4.33 22.32Q3.2 22.32 2.44 21.56Q1.68 20.8 1.68 19.68ZM12 13.6Q12 13.6 12.32 13.6Q12.65 13.6 13.13 13.13Q13.6 12.65 13.6 12Q13.6 11.35 13.13 10.88Q12.65 10.4 12 10.4Q11.35 10.4 10.88 10.88Q10.4 11.35 10.4 12Q10.4 12.65 10.88 13.13Q11.35 13.6 12 13.6Z" fill={color} />
    </svg>
  );
}
